import { createContext, useMemo } from 'react';

export type FlatDropdownContextState = {
  isOpen: boolean;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FlatDropdownContext = createContext<FlatDropdownContextState>({
  isOpen: false,
});

export const FlatDropdownContextProvider: React.FC<
  React.PropsWithChildren<FlatDropdownContextState>
> = ({ children, isOpen, setIsOpen }) => {
  const value = useMemo(() => ({ isOpen, setIsOpen }), [isOpen, setIsOpen]);

  return (
    <FlatDropdownContext.Provider value={value}>
      {children}
    </FlatDropdownContext.Provider>
  );
};
